import classes from './SidebarFooter.module.css'
import { ReactComponent as Chat } from '../../../../assets/circle.svg';
import useBotsService from '../../../../services/bot/botService';
import { useDispatch, useSelector } from 'react-redux';
import { toggle } from '../sidebarSlice'

function SidebarFooter({ collapsed = false }) {
    const botService = useBotsService()
    const isMobile = useSelector(state => state.layout).isMobile
    const { texts } = useSelector(state => state.translate)
    const dispatch = useDispatch()

    const newConversationHandler = (e) => {
        if (collapsed) {
            e.stopPropagation()
        }
        botService.resetDraft()
        if (isMobile) {
            dispatch(toggle({isOpen: false}))
        }
    }

    const footerClass = collapsed
        ? `${classes.SidebarFooter} ${classes.SidebarFooterCollapsed}`
        : classes.SidebarFooter
    const buttonClass = collapsed
        ? `${classes.Button} ${classes.ButtonCollapsed}`
        : classes.Button

    return (
        <div className={footerClass}>
            <div className={buttonClass} onClick={newConversationHandler}>
                {!collapsed ? <div style={{marginRight: "5px"}}>{texts.newConversation}</div> : null}
                <Chat/>
            </div>
        </div>
    );
}

export default SidebarFooter;
